import {
  CircularProgress,
  Divider,
  InputAdornment,
  MenuItem,
  Select,
  Stack,
  Typography,
} from "@mui/material";

function Dropdown({
  field,
  label,
  description,
  value,
  options,
  handleInputChange,
  placeholder,
  isMultiple,
  disabled = false,
  showClearAll = false,
  isLoading = false,
}) {
  const onChange = (field, value) => {
    handleInputChange(field, value);
  };

  const handleClearAll = (event) => {
    event.stopPropagation();
    handleInputChange(field, []);
  };

  return (
    <Stack>
      <Typography className="form-label" variant="label">
        {label}
      </Typography>

      <Select
        inputProps={{
          className: "form-input",
        }}
        sx={{
          borderRadius: 0,
          "& .MuiSelect-select": {
            borderRadius: 0,
          },
        }}
        value={value}
        onChange={(event) => {
          onChange(field, event.target.value);
        }}
        multiple={isMultiple}
        placeholder={placeholder}
        disabled={isLoading || disabled}
        endAdornment={
          isLoading ? (
            <InputAdornment position="end" sx={{ mr: 2 }}>
              <CircularProgress size={18} />
            </InputAdornment>
          ) : null
        }
      >
        {showClearAll &&
          isMultiple &&
          value?.length > 0 && [
            <MenuItem
              key="__clear_all__"
              onMouseDown={handleClearAll}
              sx={{
                color: "error.main",
                fontWeight: 600,
                fontSize: "0.85rem",
              }}
            >
              Clear All
            </MenuItem>,
            <Divider key="__clear_divider__" />,
          ]}
        {isMultiple
          ? options.map(({ id, label }) => (
              <MenuItem
                disabled={
                  disabled ? (value?.includes(id) ? false : true) : false
                }
                key={id}
                sx={{
                  textTransform: "uppercase",
                }}
                value={id}
              >
                {label}
              </MenuItem>
            ))
          : options.map((option) => (
              <MenuItem
                key={option}
                sx={{
                  textTransform: "uppercase",
                }}
                value={option}
              >
                {option}
              </MenuItem>
            ))}
      </Select>

      <Typography className="form-input-description" variant="p">
        {description}
      </Typography>
    </Stack>
  );
}

export default Dropdown;
